import { Check, Close, HourglassTop, Outbox } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import React from 'react'
import { formatCurrency } from '../utils/Formatter'

interface IInvoiceStatusIconProps {
  isInvoiced: boolean
  quoteStatus?: string
  invoicedAmount?: number
  balanceDue?: number
  initialInvoicePrintDate?: Date
}

const iconStyle = { verticalAlign: 'middle' }

const InvoiceStatusIcon = (props: IInvoiceStatusIconProps) => {
  const { isInvoiced, quoteStatus, invoicedAmount, balanceDue, initialInvoicePrintDate } =
    props

  if (!isInvoiced) {
    if (quoteStatus === 'Dismissed' || quoteStatus === 'Dismissed By Consumer') {
      return null
    }
    return (
      <Tooltip title="Not Invoiced">
        <Close htmlColor="#9e9e9e" style={iconStyle} />
      </Tooltip>
    )
  }

  // Balance due only applies once the invoice has been sent
  const hasBalanceDue = !!initialInvoicePrintDate && (balanceDue ?? 0) > 0
  const amounts = (
    <>
      <div>
        Invoiced Amount:{' '}
        {invoicedAmount != undefined ? formatCurrency(invoicedAmount.toString()) : 'N/A'}
      </div>
      {hasBalanceDue && <div>Balance Due: {formatCurrency(balanceDue!.toString())}</div>}
    </>
  )

  if (!initialInvoicePrintDate && balanceDue !== 0) {
    return (
      <Tooltip
        title={
          <>
            {amounts}
            <div>Not Sent</div>
          </>
        }
      >
        <Outbox color="warning" style={iconStyle} />
      </Tooltip>
    )
  }

  if (hasBalanceDue) {
    return (
      <Tooltip
        title={
          <>
            <div>Awaiting Payment</div>
            {amounts}
          </>
        }
      >
        <HourglassTop color="secondary" style={iconStyle} />
      </Tooltip>
    )
  }

  return (
    <Tooltip
      title={
        <>
          {amounts}
          <div>Paid In Full</div>
        </>
      }
    >
      <Check color="secondary" style={iconStyle} />
    </Tooltip>
  )
}

export default InvoiceStatusIcon
